import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=549ac2ef&scoped=true"
import script from "./CircularLoader.vue?vue&type=script&lang=js"
export * from "./CircularLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549ac2ef",
  null
  
)

export default component.exports